import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

class BoothErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('BoothErrorBoundary caught an error:', error);
    console.error('Component stack trace:', errorInfo.componentStack);
    this.setState({ errorInfo });
  }

  handleCopyStack = () => {
    const { errorInfo } = this.state;
    if (navigator.clipboard && errorInfo?.componentStack) {
      navigator.clipboard.writeText(errorInfo.componentStack)
        .then(() => toast.success('Stack trace copied to clipboard'))
        .catch(err => toast.error('Failed to copy stack trace'));
    }
  }

  handleCopyJson = (label, data) => {
    if (navigator.clipboard && data) {
      const jsonText = JSON.stringify(data, null, 2);
      navigator.clipboard.writeText(jsonText)
        .then(() => toast.success(`${label} copied to clipboard`))
        .catch(err => toast.error(`${label} copy failed`));
    }
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { boothJsonSchema, boothData, children } = this.props;

    if (hasError && error) {
      const shortStack = errorInfo?.componentStack?.slice(0, 10) ?? '';

      return (
        <Container fluid>
          <div
            style={{
              marginTop: '200px',
              padding: '2rem',
              backgroundColor: '#ffe5e5',
              color: '#900'
            }}
          >
            <h3>⚠️ Booth Data Validation Error</h3>
            <span>Error Message: {error.message}</span>
            <div style={{ marginTop: '1rem' }}>
              <Button
                variant="danger"
                style={{ marginRight: '0.5rem' }}
                onClick={this.handleCopyStack}
              >
                Copy Error Stack
              </Button>
              <Button
                variant="primary"
                style={{ marginRight: '0.5rem' }}
                onClick={() => this.handleCopyJson('Booth JSON Schema', boothJsonSchema)}
              >
                Copy JSON Schema
              </Button>
              <Button
                variant="success"
                onClick={() => this.handleCopyJson('Booth Data', boothData)}
              >
                Copy Booth Data
              </Button>
            </div>
          </div>
        </Container>
      );
    }

    return children;
  }
}

export default BoothErrorBoundary;
